export default __webpack_public_path__ + "static/media/abandon-cards.87ddbafb.svg";